'use client';

import { useEffect } from 'react';
import gsap from 'gsap';
import { Button } from '../../../components/ui';

const Balloons = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const timeline = gsap.timeline();
      const balloon = document.querySelector('.balloon-1');

      if (!balloon) return;

      gsap.set('.gift', { opacity: 0, y: 100, scale: 0.8 });

      timeline.fromTo('.balloon-group', { y: window.innerHeight, opacity: 0 }, { y: 0, ease: 'power1.inOut', duration: 3, delay: 3, opacity: 1 });

      gsap.fromTo('.balloon-2', { y: window.innerHeight * 2 }, { y: -1000, opacity: 1, ease: 'power1.linear', duration: 7, delay: 1 });
      gsap.fromTo('.balloon-3', { y: window.innerHeight * 2 }, { y: -1000, opacity: 1, ease: 'power1.linear', duration: 7, delay: 0.5 });
      gsap.fromTo('.balloon-4', { y: window.innerHeight * 2 }, { y: -1000, opacity: 1, ease: 'power1.linear', duration: 7, delay: 1 });
      gsap.fromTo('.balloon-5', { y: window.innerHeight * 2 }, { y: -1000, opacity: 1, ease: 'power1.linear', duration: 7 });

      const balloonAnimation = gsap.from('.balloon-1', { y: -40, duration: 0.5, repeat: -1, yoyo: true, delay: 6, ease: 'power1.in' });

      balloon.addEventListener('click', () => {
        balloonAnimation.kill();

        gsap.to('.cover', { x: 100, y: 50, rotate: 45, duration: 0.5, ease: 'power1.out' });
        gsap.to('.gift', { opacity: 1, y: -200, scale: 1.3, duration: 0.8, ease: 'power1.out' }, '+=0.1');
      });

      const takeButton = document.querySelector('.take-button');

      takeButton.addEventListener('click', () => {
        gsap.to('.balloon-group', { opacity: 0, duration: 0.5, pointerEvents: 'none' });
      });
    }
  }, []);

  const handleScroll = () => {
    const section = document.getElementById('black-offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="balloons-wrapper relative">
      <div className="balloon-group absolute left-[150px] top-[420px] cursor-pointer z-[500]">
        <div className="gift absolute top-[-100px] left-1/2 -translate-x-1/2 h-full">
          <div className="balloon-sale bg-[#D7DF23] left-1/2 -translate-x-1/2 top-[60px] rounded-5 absolute p-[8px] gap-[6px] flex flex-col items-center justify-center text-center text-[#000000] z-[200]">
            <div className="flex items-center justify-center gap-[4px]">
              <span className="text-[42px] font-bold leading-[52px]">10%</span>
              <span className="text-[28px] leading-[34px]">զեղչ</span>
            </div>
            <span className="text-[14px] leading-[17px] font-[700]">AI վիդեո անիմացիայի համար</span>
            <div className="flex w-[220px] items-center justify-center">
              <Button variant="blackOffer" className="take-button !w-[224px] hover:!w-[214px]" onClick={handleScroll}>
                Վերցնել
              </Button>
            </div>
          </div>
        </div>
        <div className="balloon balloon-1 relative z-[10] flex flex-col items-center">
          <img src="/images/offers/cover.svg" alt="Balloon" className="cover md:w-[165px] w-[145px]  h-auto -mb-[10px]" />
          <img src="/images/offers/box.svg" alt="Balloon" className="box md:w-[140px] w-[120px]  h-auto" />
        </div>
      </div>

      <div className="balloon balloon-2 absolute left-[500px] w-[170px] z-[1000]">
        <img src="/images/offers/gift.svg" alt="Balloon" className="w-full h-full object-cover" />
      </div>
      <div className="balloon balloon-3 absolute left-[800px] w-[170px] z-[1000]">
        <img src="/images/offers/gift.svg" alt="Balloon" className="w-full h-full object-cover" />
      </div>
      <div className="balloon balloon-4 absolute left-[1000px] w-[170px] z-[1000]">
        <img src="/images/offers/gift.svg" alt="Balloon" className="w-full h-full object-cover" />
      </div>
      <div className="balloon balloon-5 absolute left-[1200px] w-[170px] z-[1000]">
        <img src="/images/offers/gift.svg" alt="Balloon" className="w-full h-full object-cover" />
      </div>
    </div>
  );
};

export default Balloons;
